"use client";

import { c as _c } from "react/compiler-runtime";
import NFTImageBalance from "@/components/nft-image/NFTImageBalance";
import NFTMediaContainer from "@/components/nft-image/NFTMediaContainer";
import styles from "@/components/nft-image/NFTImage.module.scss";
import NFTModel from "@/components/nft-image/NFTModel";
import type { BaseRendererProps } from "@/components/nft-image/types/renderer-props";
export default function NFTModelRenderer(props) {
  const $ = _c(12);
  if (!("metadata" in props.nft)) {
    return null;
  }
  const animationClassName = styles.nftAnimation ?? "";
  const t0 = props.bgStyle === "";
  const t1 = `${animationClassName} ${props.imageStyle} ${props.bgStyle}`;
  let t2;
  if ($[0] !== props.height || $[1] !== props.nft || $[2] !== props.showBalance) {
    t2 = props.showBalance && <NFTImageBalance contract={props.nft.contract} tokenId={props.nft.id} height={props.height} />;
    $[0] = props.height;
    $[1] = props.nft;
    $[2] = props.showBalance;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props.id || $[5] !== props.nft) {
    t3 = <NFTModel nft={props.nft} id={props.id} />;
    $[4] = props.id;
    $[5] = props.nft;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = <NFTMediaContainer forceIronBackground={t0} className={t1}>{t2}{t3}</NFTMediaContainer>;
    $[7] = t0;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}